import { render } from "./QTextarea.vue?vue&type=template&id=22899b80&scoped=true"
import script from "./QTextarea.vue?vue&type=script&setup=true&lang=js"
export * from "./QTextarea.vue?vue&type=script&setup=true&lang=js"

import "./QTextarea.vue?vue&type=style&index=0&id=22899b80&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22899b80"],['__file',"src/components/UI/inputs/QTextarea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22899b80"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22899b80', __exports__)) {
    api.reload('22899b80', __exports__)
  }
  
  module.hot.accept("./QTextarea.vue?vue&type=template&id=22899b80&scoped=true", () => {
    api.rerender('22899b80', render)
  })

}


export default __exports__